import { render, staticRenderFns } from "./EducationMobile.vue?vue&type=template&id=766ae6d1&scoped=true&"
import script from "./EducationMobile.vue?vue&type=script&lang=js&"
export * from "./EducationMobile.vue?vue&type=script&lang=js&"
import style0 from "./EducationMobile.vue?vue&type=style&index=0&id=766ae6d1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766ae6d1",
  null
  
)

export default component.exports